export const EXTRA_CONDITIONS = 'EXTRA'
